import is_page from "./IsPage"
import is_records_list from "./IsRecordsList"

const is_records_list_page = {
    mixins: [is_page, is_records_list]
}

export default is_records_list_page
